export const US_STATES = [
  'AR',
  'WI',
  'NJ',
  'HI',
  'PA',
  'SD',
  'TN',
  'DE',
  'ND',
  'MS',
  'VI',
  'LA',
  'AK',
  'IN',
  'MP',
  'OK',
  'AL',
  'VT',
  'CO',
  'TX',
  'WV',
  'PR',
  'NE',
  'OR',
  'AS',
  'ME',
  'MI',
  'NC',
  'NY',
  'CA',
  'RI',
  'GA',
  'FL',
  'CT',
  'MD',
  'WY',
  'IA',
  'MT',
  'NH',
  'WA',
  'NM',
  'MA',
  'UT',
  'DC',
  'MO',
  'KS',
  'GU',
  'AZ',
  'SC',
  'NV',
  'MN',
  'ID',
  'KY',
  'OH',
  'VA',
  'IL',
];
